import { Component, OnInit, Input, EventEmitter, ChangeDetectorRef, ViewRef, DoCheck, ChangeDetectionStrategy } from '@angular/core';
import { Options } from "@angular-slider/ngx-slider";
import { FieldType } from "@ngx-formly/core";
import { restore } from "./../../../../assets/json/restoreTooltip.en";
import { AppStateService } from "src/app/core-module/services/app-state.service";
import { AloAocStateService } from "../../../core-module/services/state/alo-aoc-state.service";
import { FeatureDefaultsStateService } from "../../../core-module/services/state/feature-defaults-state.service";
import { InputErrorsStateService } from "../../../core-module/services/state/input-errors-state.service";

@Component({
  standalone: false,
  selector: "app-dcemergency",
  templateUrl: "./dcemergency.component.html",
  styleUrls: ["./dcemergency.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DcemergencyComponent extends FieldType implements OnInit {
  @Input() field;
  valOptions: Options = {};
  floorValue;
  ceilValue;
  defaultValue;
  enableFeatureCheckbox: LegacyAny = false;
  isResetDisabled;
  isSliderClick;
  manualRefresh: EventEmitter<void> = new EventEmitter<void>();
  sliderValue;
  textboxValue;
  defaultColor = true;
  deviceName;
  isHidden;
  isAocEnabled;
  isEnableFeature;
  inputError = false;
  quickConfigvalue: boolean;
  quickConfigCustomCSS;
  setQuickConfig;
  restoreText = restore;
  booleanValue = true;
  isDimmingEnabled;
  isDimmingEnabledValue;
  isDimmingCheckbox: LegacyAny = false;
  dimmingChecked: LegacyAny;
  fileResponse: LegacyAny;
  ngModelval: LegacyAny = [];
  calculatedPercentageVal = null;
  isEdited: LegacyAny;
  constructor(
    private ref: ChangeDetectorRef, private appState: AppStateService,
    private inputErrors: InputErrorsStateService,
    private featureDefaults: FeatureDefaultsStateService,
    private aloAoc: AloAocStateService
  ) {
    super();
  }
  setConfigurationData(value, keyVal) {
    if (value != null) {
      // Use centralized method to save feature data
      // This automatically saves to both ConfigurationData and SaveSetData
      const dcemergencyObj = Object.assign({}, value);
      this.appState.setFeatureData(keyVal, dcemergencyObj);
    }
  }
  ngOnInit() {
    this.isEdited = false;
    this.inputErrors.getDcemergencyDefaultData.subscribe((response) => {
      if (response) {
        this.resetDefaultDcemergency();
      }
    });
    this.featureDefaults.getDcemergencyDefaultColor.subscribe((response) => {
      // no-op: legacy hook kept for future default-color handling
      void response;
    });

    // Guard: Ensure field schema is loaded before accessing properties
    if (!this.field || !this.field.properties || !this.field.properties.DcEmergencyLevel) {
      // Initialize slider with safe defaults before early return
      this.valOptions = { floor: 0, ceil: 254 };
      return;
    }

    // Initialize slider options with schema values (we know DcEmergencyLevel exists)
    this.floorValue = this.field.properties.DcEmergencyLevel.minimum;
    this.ceilValue = this.field.properties.DcEmergencyLevel.maximum;
    this.defaultValue = this.field.properties.DcEmergencyLevel.default;
    this.valOptions = {
      floor: this.floorValue,
      ceil: this.ceilValue,
      disabled: false,
    };
    this.textboxValue = this.defaultValue;
    this.sliderValue = this.defaultValue;

    this.isEnableFeature = this.field.properties.DcEmergencyEnabled?.default || false;
    if (this.isEnableFeature) {
      this.enableFeatureCheckbox = true;
    }

    // Additional guard: Ensure DcEmergencyDimmingEnabled exists before processing dimming settings
    if (!this.field.properties.DcEmergencyDimmingEnabled) {
      // Slider is already initialized above, safe to return
      return;
    }

    this.isDimmingEnabledValue =
      this.field.properties.DcEmergencyDimmingEnabled.default;
    if (
      this.field.requiredProperties.includes("DcEmergencyDimmingEnabled") &&
      (this.isDimmingEnabledValue === true ||
        this.isDimmingEnabledValue === false)
    ) {
      this.isDimmingCheckbox = true;
      this.isDimmingEnabled = this.isDimmingEnabledValue;
    } else {
      this.isDimmingEnabled =
        this.field.properties.DcEmergencyDimmingEnabled.const;
      this.isDimmingCheckbox = false;
    }

    if (this.field.properties.length === 1) {
      this.isResetDisabled = true;
    } else {
      this.isResetDisabled = false;
    }

    if (this.textboxValue >= this.floorValue && !this.inputError) {
      const y = (this.textboxValue - 1) / (253 / 3) - 1;
      this.calculatedPercentageVal = Math.round(Math.pow(10, y));
    } else {
      this.calculatedPercentageVal = null;
    }
    this.aloAoc.getquickConfig.subscribe((data) => {
      if (data === "quickConfig") {
        this.quickConfigvalue = true;
        this.quickConfigCustomCSS = "quick-custom-inputbox";
        this.setQuickConfig = "quickConfig";
      } else {
        this.quickConfigvalue = false;
        this.quickConfigCustomCSS = "custom-inputbox";
        this.setQuickConfig = "standard";
      }
      setTimeout(() => {
        if (this.ref && !(this.ref as ViewRef).destroyed) {
          this.ref.detectChanges();
        }
      });
    });

    this.ngModelval["DcEmergencyDimmingEnabled"] = this.isDimmingEnabled;
    this.ngModelval["DcEmergencyEnabled"] =
      this.field.properties.DcEmergencyEnabled.default;
    this.ngModelval["DcEmergencyLevel"] = this.textboxValue;
    const unSelectedFeat = this.appState.getUnSelectedFeatConfig();
    let isConfigEdited = false;
    let featIndex: number = 0;
    if (unSelectedFeat != null) {
      unSelectedFeat.forEach((element) => {
        if (element != null && element["featureName"] != null && element["featureName"].toString().toUpperCase() === "DCEMERGENCY") {
          isConfigEdited = true;
          this.ngModelval["DcEmergencyDimmingEnabled"] = this.isDimmingEnabled =
            element["featureParameters"][0]["DcEmergencyDimmingEnabled"];
          this.ngModelval["DcEmergencyEnabled"] = this.isEnableFeature =
            element["featureParameters"][0]["DcEmergencyEnabled"];
          this.ngModelval["DcEmergencyLevel"] =
            this.textboxValue =
            this.sliderValue =
              element["featureParameters"][0]["DcEmergencyLevel"];

          unSelectedFeat.splice(featIndex, 1);
          this.appState.setUnSelectedFeatConfig(unSelectedFeat);
          this.sendDCEmergencyData();
          this.isEdited = true;
        } else {
          featIndex++;
        }
      });
    }

    /////

    this.inputErrors.sendDcemergencyInputError(this.inputError);

    if (isConfigEdited === false) {
      // Use centralized method to get feature data (prioritizes SaveSetData over ConfigurationData)
      const dcEmergencyData = this.appState.getFeatureData('DCEmergency') || this.appState.getFeatureData('DcEmergency');
      if (dcEmergencyData) {
        this.addDCEmergencyLoadedFeatureReadValues(dcEmergencyData);
      }
    }

    this.sendDCEmergencyData();
    this.isEdited = true;
  }
  addDCEmergencyLoadedFeatureReadValues(DCEMERGENCY: LegacyAny) {
    //DcEmergencyLevel: 185, DcEmergencyDimmingEnabled: false, DcEmergencyEnabled: true
    this.ngModelval["DcEmergencyDimmingEnabled"] = this.isDimmingEnabled =
      DCEMERGENCY.DcEmergencyDimmingEnabled;
    this.ngModelval["DcEmergencyEnabled"] = this.isEnableFeature =
      DCEMERGENCY.DcEmergencyEnabled;
    this.ngModelval["DcEmergencyLevel"] =
      this.textboxValue =
      this.sliderValue =
        DCEMERGENCY.DcEmergencyLevel;
    if (this.textboxValue >= this.floorValue && !this.inputError) {
      const y = (this.textboxValue - 1) / (253 / 3) - 1;
      this.calculatedPercentageVal = Math.round(Math.pow(10, y));
    } else {
      this.calculatedPercentageVal = null;
    }
    //this.checkDefaults();
    this.inputErrors.sendDcemergencyInputError(this.inputError);
    this.sendDCEmergencyData();
    this.checkValidValue();
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }
  checkDefaults() {
    this.defaultColor = true;
    if (
      this.defaultValue === Number(this.sliderValue) &&
      this.defaultValue === Number(this.textboxValue)
    ) {
      this.defaultColor = true;
    } else {
      this.defaultColor = false;
    }
    this.isDimmingEnabledValue =
      this.field.properties.DcEmergencyDimmingEnabled.default;
    if (
      this.field.requiredProperties.includes("DcEmergencyDimmingEnabled") &&
      this.isDimmingEnabledValue != this.isDimmingEnabled
    ) {
      this.defaultColor = false;
    }
    // this.isEnableFeature = this.field.properties.DcEmergencyEnabled.default;
    if (
      this.isEnableFeature === this.field.properties.DcEmergencyEnabled.default
    ) {
      //this.enableFeatureCheckbox = true;
    } else {
      this.defaultColor = false;
    }
    this.featureDefaults.setDcemergencyDefaultColor(this.defaultColor);
  }

  sliderEvent(val) {
    this.textboxValue = val;
    if (
      this.defaultValue === Number(this.sliderValue) &&
      this.defaultValue === this.textboxValue
    ) {
      this.defaultColor = true;
    } else {
      this.defaultColor = false;
    }
    if (val < this.floorValue || val > this.ceilValue) {
      this.inputError = true;
      this.inputErrors.sendDcemergencyInputError(this.inputError);
    } else {
      this.inputError = false;
      this.inputErrors.sendDcemergencyInputError(this.inputError);
    }
    this.calculatePercentageValueForDCEmergencySlider();
    this.ngModelval["DcEmergencyLevel"] = this.textboxValue;
    this.featureDefaults.setDcemergencyDefaultColor(this.defaultColor);
    this.sendDCEmergencyData();
  }

  checkValidValue(){
    if (this.textboxValue < this.floorValue || this.textboxValue > this.ceilValue) {
      this.inputError = true;
      this.inputErrors.sendDcemergencyInputError(this.inputError);
    } else {
      this.inputError = false;
      this.inputErrors.sendDcemergencyInputError(this.inputError);
    }
  }

  valueChanged(value) {
    if (value < this.floorValue || value > this.ceilValue) {
      this.inputError = true;
      this.inputErrors.sendDcemergencyInputError(this.inputError);
    } else {
      this.inputError = false;
      this.inputErrors.sendDcemergencyInputError(this.inputError);
      this.sliderValue = Number(this.textboxValue);
    }
    this.textboxValue = value;
    if (this.textboxValue >= this.floorValue && !this.inputError) {
      const y = (this.textboxValue - 1) / (253 / 3) - 1;
      this.calculatedPercentageVal = Math.round(Math.pow(10, y));
    } else {
      this.calculatedPercentageVal = null;
    }
    if (this.field.properties.length === 1) {
      this.defaultColor = true;
    } else {
      this.defaultColor = false;
    }
    if (this.textboxValue === this.defaultValue.toString()) {
      this.defaultColor = true;
    } else {
      this.defaultColor = false;
    }
    this.featureDefaults.setDcemergencyDefaultColor(this.defaultColor);
    this.ngModelval["DcEmergencyLevel"] = this.textboxValue;
    this.sendDCEmergencyData();
  }

  sliderValueChange(value) {
    this.sliderEvent(value);
  }

  resetDefaultDcemergency() {
    this.isEnableFeature = this.field.properties.DcEmergencyEnabled.default;
    if (this.isEnableFeature) {
      this.enableFeatureCheckbox = true;
    }

    this.isDimmingEnabledValue =
      this.field.properties.DcEmergencyDimmingEnabled.default;
    if (
      this.field.requiredProperties.includes("DcEmergencyDimmingEnabled") &&
      (this.isDimmingEnabledValue === true ||
        this.isDimmingEnabledValue === false)
    ) {
      this.isDimmingCheckbox = true;
      this.isDimmingEnabled = this.isDimmingEnabledValue;

      // this.dimmingChecked = true;
    } else {
      this.isDimmingEnabled =
        this.field.properties.DcEmergencyDimmingEnabled.const;
      this.isDimmingCheckbox = false;
    }
    //  if(this.dimmingChecked && !this.defaultColor ){
    //   this.isDimmingEnabled = this.dimmingChecked;
    //   this.isDimmingCheckbox = true;
    // }

    this.defaultValue = this.field.properties.DcEmergencyLevel.default;
    this.textboxValue = this.field.properties.DcEmergencyLevel.default;
    this.sliderValue = this.field.properties.DcEmergencyLevel.default;
    this.inputError = false;
    this.ngModelval["DcEmergencyEnabled"] = this.isEnableFeature;
    this.ngModelval["DcEmergencyDimmingEnabled"] = this.isDimmingEnabledValue;
    this.ngModelval["DcEmergencyLevel"] = this.textboxValue;
    this.inputErrors.sendDcemergencyInputError(this.inputError);
    this.isResetDisabled = false;
    this.isSliderClick = false;
    this.sendDCEmergencyData();
    this.ref.markForCheck();
  }

  enableFeature(event) {
    this.isEnableFeature = event;
    this.ngModelval["DcEmergencyEnabled"] = event;

    if (this.isEnableFeature === false) {
      this.isResetDisabled = true;
    } else this.isResetDisabled = false;

    this.sendDCEmergencyData();
  }

  dimmingEnabled(event) {
    this.isDimmingEnabled = event;
    this.ngModelval["DcEmergencyDimmingEnabled"] = event;
    this.sendDCEmergencyData();
  }

  private calculatePercentageValueForDCEmergencySlider() {
    if (this.textboxValue >= this.floorValue && !this.inputError) {
      const y = (this.textboxValue - 1) / (253 / 3) - 1;
      this.calculatedPercentageVal = Math.round(Math.pow(10, y));
    } else {
      this.calculatedPercentageVal = null;
    }
  }

  sendDCEmergencyData() {
    if (this.ngModelval["DcEmergencyEnabled"] === false) {
      this.isResetDisabled = true;
    }
    if (this.isEdited) {
      this.setConfigurationData(this.ngModelval, "DCEmergency");
    }
    this.checkDefaults();
    this.calculatePercentageValueForDCEmergencySlider();
    this.inputErrors.setDcemergencyEditedData(this.ngModelval);
  }

  ngOnDestroy() {
    // this.aloAoc.sendQuickConfig('');
    // this.featureDefaults.setDcemergencyDefaultColor(true);
    // this.inputErrors.sendDcemergencyDefaultData('');
    this.featureDefaults.setDcemergencyDefaultColor(true);
    // this.inputErrors.sendDcemergencyDefaultData('');
  }
}

